import React from 'react';
import PropTypes from 'prop-types';

function IconInfo({ className }) {
  return (
    <svg width="16" height="17" className={className} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.99992 15.1663C11.6818 15.1663 14.6666 12.1816 14.6666 8.49967C14.6666 4.81778 11.6818 1.83301 7.99992 1.83301C4.31802 1.83301 1.33325 4.81778 1.33325 8.49967C1.33325 12.1816 4.31802 15.1663 7.99992 15.1663Z" stroke="#88898B" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.99927 11.1637V8.49707" stroke="#88898B" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.99927 5.83301H8.00593" stroke="#88898B" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconInfo.propTypes = {
  className: PropTypes.string
}

export default IconInfo;
